import axios from 'axios';

export const getContainers = async (apiUrl, path, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (path) {
      return axios.get(`${apiUrl}?format=json&path=${path}`, settings);
  } else {
      return axios.get(`${apiUrl}?format=json`, settings);
  }
}

export const createContainer = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.put(`${apiUrl}/${data}`, null, settings);
}

export const deleteContainer = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/${data}`, settings);
}

export const getContainerDetails = async (apiUrl, container_name, path, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (path) {
      return axios.get(`${apiUrl}/${container_name}?prefix=${path}&delimiter=/&format=json`, settings);
  } else {
      return axios.get(`${apiUrl}/${container_name}?delimiter=/&format=json`, settings);
  }
}

export const setContainerDetails = async (apiUrl, container_name, changeToPublic, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  let read = 'x';
  if (changeToPublic) {
    read = '.r:*,.rlistings';
  }
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'X-Container-Read': read,
    }
  };

  return axios.post(`${apiUrl}/${container_name}/`, null, settings);
}

export const setObjectExpiry = async (apiUrl, container_name, timestamp, deleteAfter) => {
  let read = 'x';
    const settings = {
      headers: {
        'X-Remove-Delete-At': timestamp,
      }
    };
  return axios.post(`${apiUrl}/${container_name}/`, null, settings);
}

export const uploadObject = async (apiUrl, path, containerName, fileName, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'Content-Type': data.type,
    }
  };

  if (path) {
      return axios.put(`${apiUrl}/${containerName}/${path}${fileName}`, data, settings);
  } else {
      return axios.put(`${apiUrl}/${containerName}/${fileName}`, data, settings);
  }
}

export const deleteObject = async (apiUrl, containerName, objectName, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/${containerName}/${objectName}`, settings);
}
